<script setup>
import { useI18n } from 'vue-i18n';
import { useAssistantSettings } from './useAssistantSettings';
import SettingsPageLayout from 'dashboard/components-next/captain/pageComponents/assistant/settings/SettingsPageLayout.vue';
import AssistantDeliveryForm from 'dashboard/components-next/captain/pageComponents/assistant/settings/AssistantDeliveryForm.vue';

const { t } = useI18n();
const { assistant, updateAssistant } = useAssistantSettings();
</script>

<template>
  <SettingsPageLayout
    :heading="t('CAPTAIN.ASSISTANTS.SETTINGS.DELIVERY.TITLE')"
    :description="t('CAPTAIN.ASSISTANTS.SETTINGS.DELIVERY.DESCRIPTION')"
  >
    <AssistantDeliveryForm :assistant="assistant" @submit="updateAssistant" />
  </SettingsPageLayout>
</template>
